// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"144cfa20","223":"54dc69a8","374":"3712f023","677":"fd47212d"}[chunkId] + ".chunk.css";
};